export const Interaction = {
  CLICK: 'click',
  HOVER: 'hover',
};

export const interactions = [Interaction.CLICK, Interaction.HOVER];
